import { useState } from 'react';
import { Button, LinearProgress, Tooltip, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { ProposalProduct } from '@trnsact/trnsact-shared-types';
import { useMutation } from '@apollo/client';
import { UNLINK_AFTERMARKET_PRODUCT } from 'modules/desking/api';
import { UnlinkAftermarketProductResponse } from 'modules/desking/api/types';
import { useDispatch } from 'react-redux';
import { menuConstructorActions } from 'modules/aftermarketMenuConstructor/model';
import { deskingActions } from 'modules/desking/model';

export const RemoveNoLongerAvailableProduct = ({ product }: { product: ProposalProduct }) => {
  const dispatch = useDispatch();
  const [loadingUnlinkAftermarketProduct, setLoadingUnlinkAftermarketProduct] = useState(false);

  const [unlinkAftermarketProduct, { data: unlinkAftermarketProductData }] =
    useMutation<UnlinkAftermarketProductResponse>(UNLINK_AFTERMARKET_PRODUCT, {
      fetchPolicy: 'no-cache',
      context: { authRequired: true },
      onCompleted: data => {
        console.log('unlinkAftermarketProduct data:', data);
        dispatch(menuConstructorActions.removeProductFromList({ productId: product.proposalProductId }));
        dispatch(menuConstructorActions.removeProductFromAllMenuOptions({ productId: product.proposalProductId }));
        dispatch(deskingActions.unselectProduct({ productId: product.proposalProductId }));
        dispatch(deskingActions.removeProductFromList({ productId: product.proposalProductId }));
        dispatch(deskingActions.removeProductsFromMenu({ ids: [product.proposalProductId] }));
        setLoadingUnlinkAftermarketProduct(false);
      },
      onError: error => {
        setLoadingUnlinkAftermarketProduct(false);
      },
    });

  const handleRemoveProduct = async (product: ProposalProduct) => {
    try {
      setLoadingUnlinkAftermarketProduct(true);
      await unlinkAftermarketProduct({
        variables: {
          input: {
            aftermarketProductId: product.aftermarketProduct?.aftermarketProductId!,
            partnerLinkId: product.aftermarketProduct?.partnerLinks[0]?.partnerLinkId!,
          },
        },
      });
    } catch (e: any) {
      console.error('Error unlinking aftermarket product:', e);
    }
  };

  if (loadingUnlinkAftermarketProduct) {
    return (
      <span>
        Removing... <LinearProgress />
      </span>
    );
  }

  return (
    <Tooltip title="This product is no longer available from the provider. It is either discontinued or expired. It is not a valid product to add to a menu. Please click to Remove it from your product catalog.">
      <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
        <InfoIcon color="error" fontSize="small" />
        <Button
          size="small"
          color="error"
          variant="contained"
          sx={{
            textTransform: 'none',
            whiteSpace: 'nowrap',
            minWidth: 'auto',
            padding: '2px 8px',
          }}
          onClick={() => {
            handleRemoveProduct(product);
          }}
        >
          Remove Product
        </Button>
      </Box>
    </Tooltip>
  );
};
